<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">HISTORIAL DE DECLARACIÓN DOMICILIARIA</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-12 mb-3">
            <a class="btn btn-success" @click="Verifica">
              <i class="fa fa-plus"></i>
              <small> Nueva Declaración de Domicilio</small>
            </a>
          </div>
        </div> 
        <div v-for="(item, index) in vencido" :key="index">
        <div class="row mb-3">
        
          <div class="col-12 col-md-12">
            <div
              class="alert alert-danger"
              role="alert"
              style="background-color: rgba(236, 128, 109, 0.3);color:#000;"
            >
              <img src="../../assets/alerta.gif" width="2%" /><b> Atención</b><br />
               <b>VENCIÓ SU DECLARACIÓN</b> de domicilio
              dentro las 48 hrs, después de la fecha de registro. Una vez
              vencido no se tomará en cuenta como una declaración formal.
            </div>
          </div>
        </div>
        </div>
        <div v-for="(item, index) in nodeclara" :key="index">
        <div class="row mb-3">
          <div class="col-12 col-md-12">
            <div
              class="alert alert-danger"
             role="alert"
              style="background-color: rgba(236, 128, 109, 0.3);color:#000;"
            >
              <img src="../../assets/alerta.gif" width="2%" /><b> Atención</b><br />
              Debe <b>ACTUALIZAR DECLARACIÓN</b> de domicilio
              dentro las 48 hrs, después de la fecha de registro. Una vez
              vencido no se tomará en cuenta como una declaración formal.
            </div>
          </div>
        </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-12">
            <div
              class="table-responsive"
              style="overflow-y:scroll; height:380px;"
            >
              <table class="table table-bordered table-striped">
                <thead>
                  <tr class="text-center">
                  <th><small class="font-weight-bold">NRO</small></th>
                    <th>
                      <small class="font-weight-bold"
                        >ESTADO<br />DECLARACIÓN</small >
                    </th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                    <th>
                      <small class="font-weight-bold">CENTRO HOSPEDAJE</small>
                    </th>
                    <th><small class="font-weight-bold">TIPO</small></th>
                    <th><small class="font-weight-bold">DIRECCIÓN</small></th>
                    <th>
                      <small class="font-weight-bold">FECHA DECLARADA</small>
                    </th>
                    <th>
                      <small class="font-weight-bold">FECHA REGISTRO</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in domicilios" :key="index" >
                    <td
                      class="text-center" :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="{ 'alert-danger text-white': item.multa }"
                    >
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td class="text-center"  :style="index>=1 ?'color:#D5D8DC;'  : ''">
                      <!-- <small
                        v-if="item.revisado == 0 && item.verifica_estado == 1"
                      >
                      </small> -->
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-danger'"
                        v-if="item.revisado == 0 && item.verifica_estado == 1"
                      >
                        PENDIENTE
                      </small>
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : ''"
                      
                        v-if="item.revisado == 1 && item.tipo_domicilio == 'ND'"
                      >
                      <font :style="index>=1 ?''  : 'color:red;'"><b>NO DECLARA</b></font>
                        
                      </small>
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : ''"
                       
                        v-if="item.revisado == 3"
                      >
                       <font :style="index>=1 ?''  : 'color:red;'"><b>VENCIDO</b></font> 
                      </small>
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-danger'"
                        v-if="item.revisado == 0 && item.verifica_estado == 0"
                      >
                        VENCIDO
                      </small>
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :bgcolor="index>=1 ?'#e0e3e5'  : ''"
                        :class="index>=1 ? 'badge badge-light' : ''"
                        v-if="
                          item.revisado == 1 && item.nombre_domicilio != 'Null' && item.tipo_domicilio != 'ND'
                        "
                      >
                      <font :style="index>=1 ?''  : 'color:#cc9a59;'"><b>CONFIRMADO</b></font> 
                        
                      </small>
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-primary'"
                        
                        v-if="item.pago == true"
                      >
                        CANCELADO
                      </small>
                      
                      <small 
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-info'"
                     
                      v-if="item.revisado == 2">
                        CONFIRMADO
                      </small>
                    </td>
                    <!--8-->
                    <td class="text-center" :style="index>=1 ?'color:#D5D8DC;'  : ''">
                      <a
                        class="btn btn-outline-info btn-sm"
                        title="Revisar Multa"
                        v-if="item.multa"
                        @click="onModalMulta(item)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>

                      <!-- <a
                        class="btn btn-outline-success btn-sm"
                        title="Descargar Declaración"
                        v-if="item.revisado == '1'"
                       :href="'http://181.115.157.139:8678/restdgm/sitram/declaracionPDF/'+item.id_persona"
                        <i class="fa fa-print"></i>
                      </a>
                      > -->
                      <a
                      :bgcolor="index>=1 ?'#e0e3e5'  : ''"
                        class="btn btn-outline-success btn-sm"
                        title="Descargar Declaración"
                        v-if="
                        index==0 &&
                          item.revisado == '1' &&
                            item.nombre_domicilio != 'Null' &&
                            item.tipo_domicilio != 'ND'
                        "
                        :href="url + item.id_persona + '/' + item.id_domicilios"
                      >
                        <i class="fa fa-print"></i>
                      </a>
                      

                        <div class=" centrarJ">
                        
                          <router-link 
                  class="btn btn-outline-success btn-sm mr-1"
                    title="Actualizar Declaración"
                     v-if="
                                item.tipo_domicilio == 'ND' &&
                                item.verifica_estado == 1
                            "
                  :to="{
                    path: `/extranjero/ActualizarDeclaracion/${item.id_domicilios}`,
                  }"
                  >
                  <p>ACTUALIZAR DECLARACIÓN</p> 
                </router-link>
                        </div><br>                     
                    </td>
                    <td :style="index>=1 ?'color:#D5D8DC;'  : ''">
                      <!-- <small v-if="item.tipo_domicilio == 'HOS'">{{ item.emp_razon_social}}</small>
                      <small v-if="item.tipo_domicilio == 'RES'">{{ item.domicilio }}</small> -->
                      <small v-if="item.tipo_domicilio == 'ND'"
                        >NO DECLARO DOMICILIO</small
                      >

                      <small 
                      
                      v-if="item.tipo_domicilio == 'RE'"
                        >NO DECLARO DOMICILIO</small
                      >
                      <small 
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-success'"
                      v-if="item.tipo_domicilio == 'NOT'"
                        >NOTIFICACIÓN</small
                      >
                      <small v-else>{{ item.domicilio }}</small>
                    </td>
                    <!--3-->
                    <td class="text-center" :style="index>=1 ?'color:#D5D8DC;'  : ''">
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                        :class="index>=1 ? 'badge badge-light' : ''"
                        v-if="item.tipo_domicilio == 'HOS'"
                        >
                        <font :style="index>=1 ?''  : 'color:#cc9a59;'"><b>CENTRO HOSPEDAJE</b></font></small
                      >
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-info'"
                        v-if="item.tipo_domicilio == 'RE'"
                        >REINGRESO</small
                      >
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-dark'"
                        v-if="item.tipo_domicilio == 'NOT'"
                        >NOTIFICACIÓN</small
                      >
                      <small
                      :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : 'badge badge-warning'"
                        v-if="item.tipo_domicilio == 'RES'"
                        >DOMICILIO PARTICULAR</small
                      >
                      <small :style="index>=1 ?'color:#D5D8DC;'  : ''"
                      :class="index>=1 ? 'badge badge-light' : ''"
                        v-if="item.tipo_domicilio == 'ND'"
                        ><font :style="index>=1 ?''  : 'color:red'"><b>SIN DECLARACIÓN DE DOMICILIO</b></font>
                        </small
                      >
                    </td>
                    <!--4-->
                    <td :style="index>=1 ?'color:#D5D8DC;'  : ''"> 
                      <small v-if="item.empresa_persona == 1">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento }}</span>
                      </small>
                      <small v-if="item.tipo_domicilio == 'HOS'">
                        {{ item.direccion }} <br />
                        <span>{{
                          item.departamento + " - " + item.municipio
                        }}</span>
                      </small>
                      <!-- <small v-if="item.municipio!='SIN MUNICIPIO'">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento +" - "+ item.municipio }}</span>
                      </small> -->
                      <small v-if="item.tipo_domicilio == 'RES'">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento }}</span>
                      </small>
                    </td>
                    <!--5-->
                    <td class="text-center" :style="index>=1 ?'color:#D5D8DC;'  : ''">
                      <!-- <small v-if="item.tipo_domicilio == 'ND'">
                        {{ "Fecha Ingreso: " + item.fecha_reg }} 
                      </small> -->
                      <small v-if="item.tipo_domicilio == 'NOT'">
                        {{ "Fecha Notificación: " + item.fecha_reg }}
                      </small>
                      <small v-if="item.tipo_domicilio == 'RE'">
                        {{ "Fecha Reingreso: " + item.fecha_reg }}
                      </small>
                      <small
                        v-if="
                          item.tipo_domicilio != 'RE' &&
                            item.tipo_domicilio != 'NOT' &&
                            item.tipo_domicilio != 'ND'
                        "
                      >
                        {{ "De: " + item.fecha_inicio }} <br />
                        {{ "A: " + item.fecha_fin }}
                      </small>
                    </td>
                    <!--6-->
                    <td class="text-center" :style="index>=1 ?'color:#D5D8DC;'  : ''">
                      <small>
                        {{ getDateTime(item.fecha_reg) }}
                      </small>
                    </td>
                   
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      title="MULTA"
      hide-footer
      ref="modalMulta"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12">
            <p style="padding:20px;background:#f8d62b;">
              Si el ciudadano no declara su dirección en un máximo de dos días
              calendario, o se verifica que su declaración no es real, es sujeto
              a sanción según art. 37 de la reglamentación de la ley 370.
            </p>
            <p><strong>Descripción de la sanción:</strong></p>
            <p>{{ multa.observacion_sancion }}</p>
            <p><strong>Multa: </strong> {{ multa.valor_multa_ufv }} UFV</p>
            <p>
              Para subsanar su situación debe dirigirse a oficinas de la
              <b>Dirección General de Migración</b>, a objeto de regularizar su
              situación migratoria.
            </p>
          </div>
        </div>
      </div>
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";

import moment from "moment";

export default {
  components: {
    Loading,
  },
  data() {
    
    return {
       styleObject: {
    color: 'black',
    fontSize: '13px'
  },
      domicilios: [],
      nodeclara: [],
      vencido:[],
      empresa:{},
      //gif: true,
      persona: [],
      valor: "http://181.115.157.139:8678/restdgm/sitram/declaracionPDF/",
      cargando: false,
      multa: {},
      url: process.env.VUE_APP_URL + "/documento/2/",
    };
  },
  methods: {
    async onLoadDomicilios() {
      this.cargando = true;
      try {
        this.cargando = true;
        let res = await this.axios.post(`/domicilioData`);
        this.domicilios = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        this.cargando = false;
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
     async SeleccionTipoDomicilio() {
      this.cargando = true;
      try {
        let res = await this.axios.post(`/domicilioData`);
        this.domicilios = res.data.contenido;
    
        for(let i=0; i<this.domicilios.length;i++){
          
            if(this.domicilios[i].tipo_domicilio=='ND' && this.domicilios[i].revisado==1 && this.nodeclara.length<1){
                this.nodeclara.push(this.domicilios[i]);   
            }  
        }
        this.cargando = false;
      } catch (error) {
        this.cargando = false;
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
     async SeleccionVencidos() {
      this.cargando = true;
      try {
        let res = await this.axios.post(`/domicilioData`);
        this.domicilios = res.data.contenido;
    
        for(let i=0; i<this.domicilios.length;i++){
            if(this.domicilios[i].tipo_domicilio=='ND' && this.domicilios[i].revisado==3 && this.vencido.length<1){
                this.vencido.push(this.domicilios[i]);   
            }
            
        }
        this.cargando = false;
      } catch (error) {
        this.cargando = false;
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    getDate: function(date) {
      if (date != "" || date != undefined) {
        return moment(date).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    getDateTime: function(date) {
      if (date != "" || date != undefined) {
        return moment(date).format("DD/MM/YYYY HH:mm:ss");
      } else {
        return "";
      }
    },
    // actualizarDomicilio(item) {
    //  console.log("actualizar datos:",item);
        
     
    // },
    quitarDomicilio(id_domicilios) {
      this.$swal({
        title: "Esta Seguro?",
        html: "De quitar la Declaración de Domicilio.",
        type: "warning",
        confirmButtonText: "Si, Quitar Declaración",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.axios.put(`/quitarDomicilio/${id_domicilios}`);
            this.$swal({
              text: "Se quito la Declaración de Domicilio correctamente.",
              type: "success",
              confirmButtonText: "Aceptar",
            });

            this.onLoadDomicilios();
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    // formar una selección única en la tabla
    cambiaColor(item) {
      this.currentRow = item.multa;
      //console.log(this.currentRow)
    },
    showModal() {
      this.$refs["modalMulta"].show();
    },
    hideModal() {
      this.$refs["modalMulta"].hide();
    },
    onModalMulta(item) {
      this.multa = item;
      this.$refs["modalMulta"].show();
    },

    onChangeFechaIni(event) {
      let fecha = event.target._value;
      document.getElementById("fecha_fin").setAttribute("min", fecha);
    },
    async Verifica() {
      this.cargando = true;
      try {
        this.cargando = true;
        
        //let res = await this.axios.get(`/noFinalizadoDomicilio`);
        //let res = await this.axios.get(`/VerificaRevisado`);
        let res = await this.axios.get(`/VerificaDomicilioVencido`);
        let count = res.data.contenido.length;
        //let count = res.data.contenido;
        this.cargando = false;
        //if (Number(count.inicio) >= 1) {
          if (count >= 1) {
          this.$swal({
            title: "Información",
            html:
              "<b>Confirme</b> o <b>quite</b> última declaración de domicilio.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
        } else {
          this.$router.push({ name: "declaracion" });
        }
      } catch (error) {
        this.cargando = false;
      }
    },
     async updateDomicilioVencido() {
      try {
        let resultados = await this.axios.put(`/actualizarDomicilioVencido`);
        this.empresa = resultados.data.contenido;
        this.SeleccionTipoDomicilio();
      } catch (error) {
        console.log('catch: ', error);
      }
    },
  },
  created() {
    //this.Verifica();
    this.onLoadDomicilios();
    this.updateDomicilioVencido();
    this.SeleccionTipoDomicilio();
    this.SeleccionVencidos();
  },
};
</script>
<style>


@media (min-width: 979px) {
  .gif {
    display: none;
    visibility: hidden;
  }
 
}
@media (max-width: 981px) {
  .gifi {
    display: none;
    visibility: hidden;
  }
 
}
@media (min-width: 980px)and(max-width: 1000px) {
 
  .centrarJ{
   display: flex;
   justify-content: center;
   justify-items: center;
   padding-left: 500px;
  }
}
</style>
